import http from '../../../../http';
import { SERVER_URL } from '../../../../config';

export const getFooterNavData = (params) => http.get(`${SERVER_URL}/api-main/v1/footer/menu`, {params: {...params}});
